export default "__VITE_ASSET__Dlny8BjQ__"